import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";

const updateShippingFees = async (payload, token) => {
  const response = await axios.put(
    `${process.env.REACT_APP_SERVER_URL}/marketplace-shipping/fees`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

const useUpdateMarketplaceShippingFees = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation((payload) => updateShippingFees(payload, token), {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["marketplaceShippingFees"]);
      if (data?.settings) {
        queryClient.setQueryData(["marketplaceShippingFees"], data.settings);
      }
    },
  });
};

export default useUpdateMarketplaceShippingFees;
